import api from '~/services/api';

async function getColunasFiltro(nomeModulo) {
  const response = await api.get(`Modulo/${nomeModulo}/colunasfiltro`);
  return response.data;
}

async function obterDadosFiltroAvancado(data) {
  const response = await api.post(`ModuloVisao/filtroavancado`, data);
  return response;
}

async function exportarBuscaAvancada(tipoExportacao, data) {
  return api.post(`modulovisao/exportar/dinamico/${tipoExportacao}`, data);
}

export { getColunasFiltro, exportarBuscaAvancada, obterDadosFiltroAvancado };
